(function () {
  'use strict';

  function initCard(card) {
    var toggles = card.querySelectorAll('[data-bcard-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flipped = card.classList.toggle('is-flipped');
        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-bcard-card]').forEach(function (card) {
      initCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
